


















import { BCard, BCardText, BCardTitle } from "bootstrap-vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import GuideBalloon from "@/layouts/components/GuideBalloon.vue";

@Component({ components: { BCard, BCardText, BCardTitle, GuideBalloon } })
export default class SimpleMetricsCard extends Vue {
	@Prop({ default: "" }) title: string;
	@Prop({ default: 0 }) value: string;
	@Prop({ default: "" }) tooltip: string;
}
